import { Skeleton, Stack } from '@mui/material';

import styles from './SidebarSkeletonLoader.module.scss';

export const SidebarSkeletonLoader = () => {
  return (
    <Stack
      className={styles.SidebarSkeletonLoader}
      direction="column"
      gap={3.4}
    >
      {[65, 80, 86, 70, 72, 78].map((width, index) => (
        <Skeleton
          className={styles.SidebarSkeletonLoaderElement}
          key={`skeleton-${index}`}
          width={`${width}%`}
          height={20}
        />
      ))}
    </Stack>
  );
};
